/* eslint-disable */

// Import libraries
window.$ = window.jQuery = require('jquery');
window.formSerialize = require('form-serialize');

import 'lazysizes';
import 'jquery-ujs';
import 'bootstrap/dist/js/bootstrap';
import 'chosen-js/chosen.jquery'
import 'slick-carousel';
import 'slick-lightbox';
import 'bootstrap-datepicker';
import 'busy-load';

require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/disable-selection');
require ('intl-tel-input/build/js/intlTelInput.js');
require ('intl-tel-input/build/js/utils.js');

// Import custom files
import '@src/js/jQuery_prototype';
import '@src/js/chosen_image.jquery'
import '@src/js/chosen_custom';
import '@src/js/add_fields';
import '@src/js/inputs_group_animate';
import '@src/js/image_upload';
import '@src/js/parsley_config';
import '@src/js/modules/parsley';
import '@src/js/parsley_custom_validators';
import '@src/js/modules/optgroup_filter';
import '@src/js/parsley_locales';
import '@src/js/carousel_settings';
import '@src/js/ajax_selects';
import '@src/js/ajax_selects_home';
import '@src/js/control_index_tabs';
import '@src/js/datapicker_config';
import '@src/js/mobile_actions';
import '@src/js/call_seller_button_actions';
import '@src/js/animate_subscribe_success';
import '@src/js/numeric_validations';
import '@src/js/processing_ad_form';
import '@src/js/unused_moto_fields_remover';
import '@src/js/filters';
import '@src/js/flash_messages';
import '@src/js/animate_header';
import '@src/js/sticky_social_networks';
import '@src/js/back_button';
import '@src/js/blog_page';
import '@src/js/numeric_inputs';
//import '@src/js/google_ads_push_fix';
import '@src/js/partners';
import '@src/js/buy_more_leads';
import '@src/js/position_filter';
import '@src/js/modules/flash_messages';
import '@src/js/intl-tel-input';
import '@src/js/payments/paypal';
import '@src/js/payments/directpay';
import '@src/js/payments/coupon';
import '@src/js/promotions';
import '@src/js/emi_calculator';
import '@src/js/charts/leads';
import '@src/js/charts/views';
import '@src/js/dashboard';
import '@src/js/homepage';
import '@src/js/form_scroll_up';
import '@src/js/textarea_send';
import '@src/js/conversation_return_back';
import '@src/js/animate-anchor';
import '@src/js/wishlist';


// Global functions initialization

import { ConversationReturnBack } from '@src/js/conversation_return_back';
import {
  initRangedPrice,
  initRangedYear,
  initRangedSlider,
  initBuyLeadsSlider
} from '@src/js/ranged_slider_settings';
import readURL from '@src/js/modules/read_url';
import globalInitSlick from '@src/js/modules/global_init_slick';
import headerButtons from '@src/js/modules/header_buttons';
import animateScrollUp from '@src/js/modules/scroll_up';
import {
  gmap_form,
  gmap_show
} from '@src/js/modules/google_map';
import {
  enableSendButton
} from '@src/js/modules/validations';
import { DiscountForm } from '@src/js/discount_form';
import { ScrollUp } from '@src/js/form_scroll_up';
import { SendForm } from '@src/js/textarea_send';
window.DiscountForm = DiscountForm;

window.initRangedPrice = initRangedPrice;
window.initRangedSlider = initRangedSlider;
window.initRangedYear = initRangedYear;
window.initBuyLeadsSlider = initBuyLeadsSlider;
window.readURL = readURL;
window.globalInitSlick = globalInitSlick;
window.headerButtons = headerButtons;
window.animateScrollUp = animateScrollUp;
window.gmap_form = gmap_form;
window.gmap_show = gmap_show;
window.enableSendButton = enableSendButton;
window.ScrollUp = ScrollUp;
window.SendForm = SendForm;
window.ConversationReturnBack = ConversationReturnBack;
window.Cookies = require('js-cookie');

let args = [
  '\n %c %c %c :Codica  %c ' + ' %c ' + ' https://www.codica.com/  %c %c \n\n',
  'background: #f14e2e; padding:5px 0;',
  'background: #f14e2e; padding:5px 0;',
  'color: #f14e2e; background: #030307; padding:5px 0;',
  'background: #f14e2e; padding:5px 0;',
  'background: #f14e2e; padding:5px 0; color: #fff',
  'background: #f14e2e; padding:5px 0;',
  'color: #f14e2e; background: #fff; padding:5px 0;'
];

console.log.apply(console, args);



// WEBPACK FOOTER //
// ./app/webpacker/packs/application.js